<template>
    <b-container class="mt-5 pb-5">

        <b-row class="mt-3 mb-5">
            <b-col>
                <b-link class="link" :to="{name: 'conference-details', params: {id}}"><i class="far fa-long-arrow-left mr-2"></i>Back to Conference Details</b-link>
            </b-col>
        </b-row>

        <div class="mb-5">
            <h3 class="text-success">{{registration.firstName}} {{registration.lastName}}</h3>
            <div>{{registration.conference.title}}</div>
        </div>

        <b-nav class="reg-nav mb-5">
            <b-nav-item exact-active-class="active" :to="{name: 'reg-info', params: {reg: registration}}"><i class="far fa-user mr-2"></i>Registration</b-nav-item>
            <b-nav-item exact-active-class="active" :to="{name: 'reg-po'}" v-if="registration.paymentType === 'po'"><i class="far fa-money-check-edit mr-2"></i>Purchase Order (P.O.)</b-nav-item>
            <b-nav-item exact-active-class="active" :to="{name: 'reg-comm'}"><i class="far fa-comment mr-2"></i>Communicate</b-nav-item>
            <b-nav-item exact-active-class="active" :to="{name: 'reg-edit'}"><i class="far fa-pencil mr-2"></i>Edit</b-nav-item>
            <b-nav-item exact-active-class="active" :to="{name: 'reg-tools', params: {reg: registration}}"><i class="far fa-cog mr-2"></i>Tools</b-nav-item>
        </b-nav>

        <router-view/>

    </b-container>
</template>

<script>
    import {mapActions} from "vuex";

    export default {
        name: "reg-details",
        props: ['id', 'code'],
        data: function () {
            return {
                registration: {
                    conference: {}
                },
            }
        },
        methods: {
            ...mapActions(['getRegistrationByCode']),

        },
        mounted: function () {
            this.getRegistrationByCode(this.code).then(reg => {
                this.registration = reg;
            }, err => {
                console.error(err);
            });
        }
    }
</script>

<style lang="scss" scoped>

    @import '~@/assets/scss/_variables.scss';

    a.link {
        color: $success;
    }

    .reg-nav {
        .nav-item {
            margin-right: 1.5rem;

            a {
                padding: 0.2rem;

                color: $success;
                font-size: 1.1rem;

                &.active {
                    border-bottom: 3px solid $success;
                }
            }
        }
    }

</style>